/**
 * Device Detection Plugin
 * تشخیص نوع دستگاه و مرورگر کاربر برای SSR-friendly rendering
 */

export default defineNuxtPlugin((nuxtApp) => {
  const detectDevice = () => {
    if (process.server) {
      // Server-side: از headers استفاده می‌کنیم
      const headers = useRequestHeaders();
      const userAgent = headers['user-agent'] || '';
      
      return {
        mobile: /mobile/i.test(userAgent),
        tablet: /tablet|ipad/i.test(userAgent),
        android: /android/i.test(userAgent),
        apple: /iphone|ipad|ipod|macintosh/i.test(userAgent),
        ios: /iphone|ipad|ipod/i.test(userAgent),
      };
    }
    
    // Client-side: از window.navigator استفاده می‌کنیم
    const ua = window.navigator.userAgent;
    
    return {
      mobile: /mobile/i.test(ua),
      tablet: /tablet|ipad/i.test(ua),
      android: /android/i.test(ua),
      apple: /iphone|ipad|ipod|macintosh/i.test(ua),
      ios: /iphone|ipad|ipod/i.test(ua),
    };
  };

  const device = detectDevice();

  // Provide device info globally
  return {
    provide: {
      device,
    },
  };
});
